__turbopack_context__.v({
  "oneTrustButton": "onetrust-modal-button-module-scss-module__oI68_q__oneTrustButton",
});
